import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientDataForAppoinment } from '../service/make-appoinment.model';
import { MakeAppointmentService } from '../service/make-appointment.service';
import { SharedService } from 'src/app/services/shared.service';
import { ToastType } from 'src/app/enums/enums';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-ortho-appointment',
  templateUrl: './ortho-appointment.component.html',
  styleUrls: ['./ortho-appointment.component.scss']
})
export class OrthoAppointmentComponent {
  OrthoAppoinmentForm: FormGroup;
  @Input() patientData: PatientDataForAppoinment = {
    id: 0,
    name: '',
    caseName: '',
    da: '',
    de: '',
    clinicId: 0,
    isDischarged: false
  };
  isData = false;
  activeModal = inject(NgbActiveModal);
  currentDate = new Date();
  constructor(private makeAppointmentService: MakeAppointmentService, private sharedService: SharedService, private toast: ToastService) {
    this.OrthoAppoinmentForm = new FormGroup({
      nextOrthoAppt: new FormControl(null),
      orthoPRN: new FormControl(false),
      //ortho: new FormControl(''),
      orthoFU1: new FormControl(null),
      orthoFU2: new FormControl(null),
      orthoFU3: new FormControl(null),
      orthoFU4: new FormControl(null),
      orthoFU5: new FormControl(null),
      orthoFU6: new FormControl(null),
      orthoFU7: new FormControl(null),
      orthoFU8: new FormControl(null),
      orthoFU9: new FormControl(null),
      surgeryRx: new FormControl(false),
      surgeryDate1: new FormControl(null),
      surgeryPerfomed1: new FormControl(false),
      nextSurgery1: new FormControl(false),
      surgeryDate2: new FormControl(null),
      surgeryPerfomed2: new FormControl(false),
      nextSurgery2: new FormControl(false)
    });
    this.currentDate.setHours(0, 0, 0, 0);
  }

  ngOnInit() {
    const fieldsToWatch = ['nextOrthoAppt', 'orthoPRN', 'surgeryPerfomed', 'surgeryDate'];
    fieldsToWatch.forEach((fieldName) => {
      this.OrthoAppoinmentForm.get(fieldName)?.valueChanges.subscribe((value) => {
        switch (fieldName) {
          case 'nextOrthoAppt':
          case 'orthoPRN':
            this.checkDate('nextOrthoApptDiv', 'orthoPRN', 'nextOrthoAppt');
            break;
          case 'surgeryDate':
          case 'surgeryPerfomed':
            this.checkDate('surgeryDateDiv', 'surgeryPerfomed', 'surgeryDate');
            break;
        }
      });
    });
    this.getOrthoAppoinment(this.patientData.id);
  }

  getOrthoAppoinment(id: number) {
    this.makeAppointmentService.getOrthoAppoinment(id).subscribe({
      next: (res) => {
        this.isData = true;
        const data = this.sharedService.changeDateToString(res.result);
        const { id, patientId, clinicId, ortho, ...rest } = data;
        this.OrthoAppoinmentForm.setValue(rest);
      },
      error: (error) => {
        console.error(error, 'error');
      },
      complete: () => {}
    });
  }

  makeOrthoAppoinment() {
    let data = this.OrthoAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;
    this.makeAppointmentService.makeOrthoAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'Ortho Appointment created successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  updateOrthoAppointment() {
    let data = this.OrthoAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;

    const dateFields = ['nextOrthoAppt', 'orthoFU1', 'orthoFU2', 'orthoFU3', 'orthoFU4', 'orthoFU5', 'orthoFU6', 'orthoFU7', 'orthoFU8', 'orthoFU9', 'surgeryDate1', 'surgeryDate2'];
    dateFields.forEach((field) => {
      if (data[field] === '') {
        data[field] = null;
      }
    });

    this.makeAppointmentService.updateOrthoAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'Ortho Appointment updated successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  checkDate(div: string, checkbox: string, mainField: string) {
    const myDiv = document.getElementById(div);
    const checkboxValue = this.OrthoAppoinmentForm.get(checkbox)?.value;
    const mainFieldValue = this.OrthoAppoinmentForm.get(mainField)?.value;
    if (!checkboxValue && this.isData && mainFieldValue) {
      const date2 = new Date(mainFieldValue);
      if (this.currentDate > date2) {
        myDiv?.classList.add('highlight-red');
      } else {
        myDiv?.classList.remove('highlight-red');
      }
    } else {
      myDiv?.classList.remove('highlight-red');
    }
  }
}
